import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableLoyaltyMigration',
  initialState: false,
  reducers: {
    setEnableLoyaltyMigration(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableLoyaltyMigration } = slice.actions;

export default slice.reducer;
